/**
 * Triggered Alert Atoms - State management for Triggered Alerts (Read-only)
 *
 * Triggered Alerts = Alerts raised during follow-ups
 * Read-only from triggered_alerts table
 *
 * NO LOCAL TYPES - All types come from @/isomorphic/schemas
 *
 * NOTE: All action functions have been moved to actions/triggered-alert-actions.ts
 * This file now only contains atom definitions (state)
 */

import { atom } from "jotai";
import type { TriggeredAlert } from "@/isomorphic/schemas";
import type { AtomStatus, AtomError } from "@/frontend/types/atoms";

// ============================================================================
// ATOMS
// ============================================================================

/**
 * Internal atoms: Triggered alerts (from API)
 * Exported for use in action functions
 */
export const _apiFollowUpAlertsAtom = atom<TriggeredAlert[]>([]);
export const _apiWorkspaceUnresolvedAlertsAtom = atom<TriggeredAlert[]>([]);

export const followUpAlertsStatusAtom = atom<AtomStatus>("init");
export const workspaceUnresolvedAlertsStatusAtom = atom<AtomStatus>("init");
export const followUpAlertsErrorAtom = atom<AtomError>(null);
export const workspaceUnresolvedAlertsErrorAtom = atom<AtomError>(null);

/**
 * Public atoms
 */
export const followUpAlertsAtom = atom<TriggeredAlert[]>((get) => {
  return get(_apiFollowUpAlertsAtom);
});

export const workspaceUnresolvedAlertsAtom = atom<TriggeredAlert[]>((get) => {
  return get(_apiWorkspaceUnresolvedAlertsAtom);
});
